module.exports = __webpack_public_path__ + "img/FallingIcon.d0defeb0.svg";